export default __webpack_public_path__ + "static/media/BQ.a7fdb74e.svg";